import React from 'react';
import PropTypes from 'prop-types';

function TriggerLabel({ className = '', children }) {
  return <span className={`ws-trigger-label ${className}`}>{children}</span>;
}

TriggerLabel.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  className: PropTypes.string,
};

export default TriggerLabel;
